export const name = 'testService' as const
